<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
               style="height: 100%;">
        <v-layout row class="my-10">
            <v-flex md12 sm12>
                <div class="ml-6">
                    <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Choose your direct mail template</div>

                    <v-layout row class="layout__width-1100px layout__margin-0-auto">
                        <v-flex md4 px-2>
                            <v-card class="ma-4 text-center" width="340" height="500" color="white" raised @click="templateTypeChosen('my-templates')">
                                <v-img class="white--text align-end" src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/MyRav_My_Templates.jpg" eager>
                                </v-img>

                                <div class="text__colour-teal pt-4 text__size-26 text__style-bold ">My Templates</div>

                                <v-card-subtitle class="text__colour-teal text__size-18 pb-0 layout__margin__bottom-20">
                                    Your saved templates appear here
                                </v-card-subtitle>

                                <v-card-actions class="template-item">
                                    <v-row align="center" justify="center" class="py-4">
                                        <el-button class="button__background-red button__base layout__width-200px"
                                                    v-on:click="templateTypeChosen('my-templates')">Continue
                                        </el-button>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex md4 px-2>
                            <v-card class="ma-4 text-center" width="340" height="500" color="white" raised @click="templateTypeChosen('template-gallery')">
                                <v-img class="white--text align-end" src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/MyRav_Template_Gallery.jpg" eager>
                                </v-img>

                                <div class="text__colour-teal pt-4 text__size-26 text__style-bold ">Template Gallery</div>

                                <v-card-subtitle class="text__colour-teal text__size-18 pb-0 layout__margin__bottom-20">
                                    Browse the top performing prospecting templates
                                </v-card-subtitle>

                                <v-card-actions class="template-item">
                                    <v-row align="center" justify="center" class="py-4">
                                        <el-button class="button__background-red button__base layout__width-200px"
                                                    v-on:click="templateTypeChosen('template-gallery')">Continue
                                        </el-button>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex md4 px-2>
                            <v-card class="ma-4 text-center" width="340" height="500" color="white" raised>
                                <v-img class="white--text align-end" src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/MyRav_Upload.jpg" eager>
                                </v-img>

                                <div class="text__colour-grey pt-4 text__size-26 text__style-bold ">Upload</div>

                                <v-card-subtitle class="text__colour-grey text__size-18 pb-0 layout__margin__bottom-20">
                                    We'll be adding the ability to upload your own templates, in the meantime contact us to upload
                                </v-card-subtitle>

                                <v-card-actions class="template-item">
                                    <v-row align="center" justify="center" class="py-4">
                                        <el-button class="button__background-red button__base layout__width-200px" disabled
                                                    href="mailto:orders@printconcern.co.uk">Coming soon
                                        </el-button>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <div class="layout__padding__top-40px">
                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                                    v-on:click="navigate('data-preview');">Back
                            </el-button>
                        </div>
                    </v-layout>

                    <v-overlay :value="loading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </div>
            </v-flex>

        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: 'InstantMarketingTemplate',
        components: {
        },
        mixins: [axios],
        data: () => ({
            loading: false,
        }),
        watch: {
        },
        mounted() {
            parent.postMessage('ScrollIntoView', '*');
        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path,
                });
            },
            templateTypeChosen(templateType) {
                window.sessionStorage.setItem('_templateType', templateType);
                this.navigate('select-design');
            }
        }
    };
</script>
